import { LayoutConstants } from "layout/LayoutConstants";
import { DrawerOpenState } from "layout/left-menu/types";

import { styled, useMediaQuery, useTheme } from "@mui/material";
import Drawer, { DrawerProps } from "@mui/material/Drawer";
import { SxProps } from "@mui/system";

interface Props extends Omit<DrawerProps, "open" | "variant"> {
  openState: DrawerOpenState;
}

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    whiteSpace: "nowrap",
    display: "flex",
    justifyContent: "space-between",
    overflowX: "hidden",
    position: "absolute",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    borderWidth: "0px",
    width: LayoutConstants.leftMenu.width.closed
  },

  [theme.breakpoints.down("md")]: {
    height: "100vh",

    "& .MuiDrawer-paper": {
      width: 0
    }
  }
}));

export const LeftMenuDrawer = ({
  openState,
  children,
  ...drawerProps
}: Props) => {
  const theme = useTheme();

  const showModal = useMediaQuery(theme.breakpoints.down("md"));
  const drawerVariant = showModal ? "temporary" : "permanent";
  const isOpen = openState >= DrawerOpenState.Open;

  const sx: SxProps = {
    "& .MuiDrawer-paper": {
      ...(isOpen && {
        transitionDuration: `${theme.transitions.duration.enteringScreen}`,
        width: LayoutConstants.leftMenu.width.open,

        [theme.breakpoints.down("md")]: {
          width: LayoutConstants.leftMenu.width.open
        }
      }),

      position: openState === DrawerOpenState.Open ? "relative" : undefined
    }
  };

  return (
    <StyledDrawer
      open={isOpen}
      variant={drawerVariant}
      aria-modal={showModal}
      sx={sx}
      {...drawerProps}
    >
      {children}
    </StyledDrawer>
  );
};
